import { Selector } from '../../lib/generated/zeus';
import { qualificationSelector } from './qualification';

export const userSelector = Selector('user')({
  id: true,
  first_name: true,
  last_name: true,
  email_address: true,
  external_id: true,
  display_name: true,
  user_type: true,
  user_name: true,
});

export const userWithQualificationSelector = Selector('user')({
  id: true,
  first_name: true,
  last_name: true,
  external_id: true,
  display_name: true,
  user_type: true,
  user_name: true,
  group_membership: [
    {
      where: {},
    },
    {
      group: {
        qualifications: [
          {
            where: {},
          },
          qualificationSelector,
        ],
      },
    },
  ],
});

export const userWithCalendarIdSelector = Selector('user')({
  ...userSelector,
  private_calendar_id: true,
});
